module.exports = __webpack_public_path__ + "img/ico_checkout_front.8f3884bf.svg";